<template>
  <div id="menu">
    <router-link to="/subscription/info">
      <font-awesome-icon icon="info-circle" />Subscription
    </router-link>
    <router-link
      v-if="this.$store.state.subscription.active == 1"
      to="/subscription/customer"
    >
      <font-awesome-icon icon="address-card" />Customer data
    </router-link>
    <router-link
      v-if="this.$store.state.subscription.active == 1"
      to="/subscription/payment"
    >
      <font-awesome-icon icon="money-check" />Payment information
    </router-link>
    <router-link to="/subscription/all">
      <font-awesome-icon icon="calendar" />All Subscriptions
    </router-link>
    <router-link to="/subscription/history">
      <font-awesome-icon icon="history" />Payment history
    </router-link>
    <button id="search-back-button" @click="backToSearch">
      <font-awesome-icon icon="sign-out-alt" />Back to Search
    </button>
  </div>
</template>

<script>
export default {
  name: "Menu",
  methods: {
    backToSearch() {
      this.$router.push({ path: "/", query: { logout: true } });
      setTimeout(() => {
        location.reload();
      }, 1000);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#menu a.router-link-active:hover {
  color: #ffc20f;
}

#menu a.router-link-active {
  color: #888888;
  background-color: white;
}
#menu {
  position: relative;
  font-size: 16px;
  width: 100%;
  min-width: 225px;
  height: 12%;
  display: flex;
  float: left;
  flex-direction: row;
  background-color: #ffc20f;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  align-items: flex-end;
  padding-right: 60px;
  padding-left: 60px;
}

#search-back-button {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 16px;
  padding: 8px 12px;
  background-color: transparent;
  border: none;
  color: white;
  cursor: pointer;
}

#logout-button:hover {
  color: #888888;
}

svg {
  margin-right: 5px;
}

#menu a {
  width: 17%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: white;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  background-color: #fdd86a;
  margin-left: 2px;
  margin-right: 2px;
}

svg {
  margin-right: 10px;
  font-size: 18px;
}

#menu a:hover {
  color: #888888;
  background-color: white;
}
</style>
